import { APICallV3Post } from 'reactApp/api/APICall';

export class ViewVKArchiveInfoAPICall extends APICallV3Post {
    _method = 'unzip/embedded/view';
}
